import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.close();
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return undefined;
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-sync"
          },
          on: {
            "reset": _vm.reset
          }
        }, [_vm._v(_vm._s(_vm.$i18n_t('Common.reset')))]), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-save"
          },
          on: {
            "click": _vm.handleSubmit
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.save')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c(VForm, {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('core-userfinder', {
    attrs: {
      "userId": _vm.lclUserId,
      "hideIcon": true
    },
    on: {
      "userSelected": _vm.userSelected
    }
  })], 1), _c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.email'),
      "readonly": "",
      "disabled": ""
    },
    model: {
      value: _vm.lclEmail,
      callback: function ($$v) {
        _vm.lclEmail = $$v;
      },
      expression: "lclEmail"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-dtwin-finder', {
    attrs: {
      "objectFilter": _vm.isValidDoorParent,
      "userId": _vm.lclUserId,
      "label": !_vm.lclUserId ? _vm.$i18n_t('IS.FM.AccessMgmt.selectUserFirst') : _vm.$i18n_t('IS.FM.AccessMgmt.selectBuilding'),
      "disabled": !_vm.lclUserId ? true : false,
      "requiredErrorText": _vm.$i18n_t('IS.FM.AccessMgmt.selectBuilding'),
      "required": ""
    },
    model: {
      value: _vm.lclTwinId1,
      callback: function ($$v) {
        _vm.lclTwinId1 = $$v;
      },
      expression: "lclTwinId1"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_vm.lclTwinId1 ? _c('core-dtwin-finder', {
    attrs: {
      "objectFilter": _vm.isValidDoor,
      "userId": _vm.lclUserId,
      "parentId": _vm.lclTwinId1,
      "label": !_vm.lclTwinId1 ? _vm.$i18n_t('IS.FM.AccessMgmt.selectBuildingFirst') : _vm.$i18n_t('IS.FM.AccessMgmt.selectDoor'),
      "disabled": !_vm.lclTwinId1 ? true : false,
      "requiredErrorText": _vm.$i18n_t('IS.FM.AccessMgmt.selectDoor'),
      "required": ""
    },
    model: {
      value: _vm.lclTwinId2,
      callback: function ($$v) {
        _vm.lclTwinId2 = $$v;
      },
      expression: "lclTwinId2"
    }
  }) : _vm._e()], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    staticClass: "mb-1",
    model: {
      value: _vm.panel,
      callback: function ($$v) {
        _vm.panel = $$v;
      },
      expression: "panel"
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', [_vm._v(_vm._s(_vm.$i18n_t('IS.FM.AccessMgmt.TimeLimit')))])]), _c(VExpansionPanelContent, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "px-2",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('core-dateTime-picker', {
    attrs: {
      "from": _vm.lclDateFrom / 1000,
      "expandIcon": "",
      "allowNull": "",
      "dateOnly": "",
      "hideBorderOnCollapse": ""
    },
    on: {
      "date:picked": _vm.fromDatePicked
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function ({
        startDate
      }) {
        return [_c(VTextField, {
          attrs: {
            "value": startDate,
            "color": _vm.color,
            "label": _vm.$i18n_t('IS.FM.AccessMgmt.keyValidFrom'),
            "append-icon": "fal fa-calendar-day",
            "readonly": "",
            "disabled": "",
            "hide-details": ""
          }
        })];
      }
    }])
  })], 1), _c(VCol, {
    staticClass: "px-2",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('core-dateTime-picker', {
    attrs: {
      "from": _vm.lclDateTo / 1000,
      "expandIcon": "",
      "allowNull": "",
      "dateOnly": "",
      "hideBorderOnCollapse": ""
    },
    on: {
      "date:picked": _vm.toDatePicked
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function ({
        startDate
      }) {
        return [_c(VTextField, {
          attrs: {
            "value": startDate,
            "color": _vm.color,
            "label": _vm.$i18n_t('IS.FM.AccessMgmt.keyValidTo'),
            "append-icon": "fal fa-calendar-day",
            "readonly": "",
            "disabled": "",
            "hide-details": ""
          }
        })];
      }
    }])
  })], 1), _c(VCol, {
    staticClass: "px-2",
    attrs: {
      "cols": "12"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "items": _vm.daysList,
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.WeekDay'),
      "menu-props": {
        offsetY: true,
        top: true
      },
      "search-input": _vm.searchDays,
      "item-text": "dayText",
      "item-value": "dayId",
      "autocomplete": "off",
      "attach": "",
      "chips": "",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "multiple": ""
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.searchDays = $event;
      },
      "update:search-input": function ($event) {
        _vm.searchDays = $event;
      },
      "change": function ($event) {
        _vm.searchDays = '';
      }
    },
    model: {
      value: _vm.lclDays,
      callback: function ($$v) {
        _vm.lclDays = $$v;
      },
      expression: "lclDays"
    }
  })], 1), _c(VCol, {
    staticClass: "pr-0 pl-2",
    attrs: {
      "cols": "5",
      "md": "2"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "items": _vm.hourList,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Common.FromHour'),
      "menu-props": {
        offsetY: true,
        top: true
      },
      "autocomplete": "off",
      "hide-details": "",
      "attach": ""
    },
    on: {
      "change": function ($event) {
        return _vm.validate();
      }
    },
    model: {
      value: _vm.lclTimeFromHour,
      callback: function ($$v) {
        _vm.lclTimeFromHour = $$v;
      },
      expression: "lclTimeFromHour"
    }
  })], 1), _c(VCol, {
    staticClass: "pt-4 px-0",
    attrs: {
      "cols": "2",
      "md": "1"
    }
  }, [_vm._v(":")]), _c(VCol, {
    staticClass: "pl-0 pr-2",
    attrs: {
      "cols": "5",
      "md": "2"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "items": _vm.minuteList,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Common.FromMinute'),
      "menu-props": {
        offsetY: true,
        top: true
      },
      "autocomplete": "off",
      "hide-details": "",
      "attach": ""
    },
    on: {
      "change": function ($event) {
        return _vm.validate();
      }
    },
    model: {
      value: _vm.lclTimeFromMinute,
      callback: function ($$v) {
        _vm.lclTimeFromMinute = $$v;
      },
      expression: "lclTimeFromMinute"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "0",
      "md": "2"
    }
  }), _c(VCol, {
    staticClass: "pr-0 pl-2",
    attrs: {
      "cols": "5",
      "md": "2"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "items": _vm.hourList,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Common.ToHour'),
      "menu-props": {
        offsetY: true,
        top: true
      },
      "autocomplete": "off",
      "hide-details": "",
      "attach": ""
    },
    on: {
      "change": function ($event) {
        return _vm.validate();
      }
    },
    model: {
      value: _vm.lclTimeToHour,
      callback: function ($$v) {
        _vm.lclTimeToHour = $$v;
      },
      expression: "lclTimeToHour"
    }
  })], 1), _c(VCol, {
    staticClass: "pt-4 px-0",
    attrs: {
      "cols": "2",
      "md": "1"
    }
  }, [_vm._v(":")]), _c(VCol, {
    staticClass: "pl-0 pr-2",
    attrs: {
      "cols": "5",
      "md": "2"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "items": _vm.minuteList,
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.ToMinute'),
      "menu-props": {
        offsetY: true,
        top: true
      },
      "autocomplete": "off",
      "hide-details": "",
      "attach": "",
      "outlined": ""
    },
    on: {
      "change": function ($event) {
        return _vm.validate();
      }
    },
    model: {
      value: _vm.lclTimeToMinute,
      callback: function ($$v) {
        _vm.lclTimeToMinute = $$v;
      },
      expression: "lclTimeToMinute"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [!_vm.isMobile ? _c('span', [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-sync"
    },
    on: {
      "click": _vm.resetTimeRestriction
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$i18n_t('Common.reset')) + "\n                    ")])], 1) : _c('span', [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-sync"
    },
    on: {
      "click": _vm.resetTimeRestriction
    }
  })], 1)]), _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "0",
      "md": "2"
    }
  }), _c(VCol, {
    class: _vm.rolloverDayCaption ? `mt-0 mb-2 ${_vm.color}` : 'mt-0 mb-2',
    staticStyle: {
      "border-radius": "4px"
    },
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.rolloverDayCaption) + "\n                ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };